import { useI18nContext, Language } from './useI18nContext';

export const useTranslation = (): {
  t: (key: string, options?: any) => string;
  language: Language;
  changeLanguage: (lang: Language) => void;
} => {
  const { t, language, changeLanguage } = useI18nContext();

  return { t, language, changeLanguage };
};

export default useTranslation;
